package org.gstechnovos.jexonplastech.sections.about.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.s

val CoreValuesContainerStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier
            .fillMaxWidth()
            .backgroundColor(palette.custom.white) // Clean white to contrast with the previous gray section
    }
}

val ValueCardStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier
            .fillMaxWidth()
            .height(100.percent) // Ensures all cards in the grid stretch to the same height
            .padding(32.px)
            .borderRadius(16.px)
            .backgroundColor(palette.custom.lightGray)
            .transition(
                Transition.of("transform", 0.3.s),
                Transition.of("box-shadow", 0.3.s)
            )
    }
    hover {
        Modifier
            .translateY((-6).px)
            .boxShadow(0.px, 12.px, 30.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.08f))
    }
}